import {
    Component,
    Inject,
    ChangeDetectorRef,
    LOCALE_ID,
    OnInit,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { formatDate, DatePipe } from "@angular/common";

import { Invoices } from "../../../_models/table-models";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { InvoiceService } from "src/app/_services/invoice.service";
import { DataExportService } from "src/app/_services/dataExportService";
import * as moment from "moment-timezone";

@Component({
    selector: "app-invoices",
    templateUrl: "./invoices.component.html",
    styleUrls: ["./invoices.component.scss"],
})
export class InvoicesComponent implements OnInit {
    searchTerm: string = "";
    invoices: Invoices[] = [];
    allInvoices: Invoices[] = [];
    responseData: any;
    isError: any;
    isEmpty = false;
    loading = true;
    displayName: any;
    page = 1;
    pageSize = 10;
    collectionSize: any;
    invs: any;
    tempDataset = [];
    sessionExpired = false;
    errorMsg = "";
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };
    selectedOption = false;
    filterBy: any;
    canSubmitNonPo = false;
    canSubmitLogistics = false;
    vendorData: any;
    tableData: any;
    gstExist: boolean;
    checkproperty: string;
    isSelected = false;
    invoiceSelected;
    impersonate;

    constructor(
        private router: Router,
        private http: HttpClient,
        private authService: AuthService,
        private invoiceService: InvoiceService,
        private exportService: DataExportService,
        private cdref: ChangeDetectorRef,
        private datePipe: DatePipe,
        @Inject(LOCALE_ID) public locale: string
    ) {}

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    cleanRoute(path: any) {
        this.invoices.forEach((r: any) => {
            for (let key in r) {
                console.log(`${key}: ${r[key]}`);
            }
        });
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    onSelectChanges(event) {
        this.isSelected = event.target.checked;
    }

    sendInvoice() {
        localStorage.setItem("selectionType", "invoice");
        this.router.navigate([
            "/upload-credit-note",
            this.invoiceSelected.barcode,
        ]);
    }

    fetchVendorData() {
        const vendorData = {
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.authService.fetchVendorMasterData(vendorData).subscribe(
            (res) => {
                this.loading = false;
                this.responseData = res;
                if (this.responseData.status == "success") {
                    this.vendorData = this.responseData.supplier;

                    if (this.vendorData.logistics_flag === "TRUE") {
                        this.canSubmitLogistics = true;
                    } else {
                        this.canSubmitLogistics = false;
                    }

                    if (this.vendorData.non_po_flag === "TRUE") {
                        this.canSubmitNonPo = true;
                    } else {
                        this.canSubmitNonPo = false;
                    }
                } else {
                    this.isError = true;
                    console.log("Error Here");
                }
            },
            (error) => {
                this.loading = false;
                this.isError = true;
                console.log(error);
            }
        );
    }

    fetchInvoices() {
        const userData = {
            action: "list",
            docTyp: "invoice",
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
        };

        this.invoiceService.fecthInvoices(userData).subscribe(
            (res) => {
                this.responseData = res;

                if (this.responseData.status === "successful") {
                    this.invoices = this.responseData.invoice;
                    this.invoices.forEach((invoice) => {
                        if (
                            typeof invoice.payment_due_date_iso !== "undefined"
                        ) {
                            const gmtMoment = moment(
                                invoice.payment_due_date_iso
                            );
                            const istMoment = gmtMoment.tz("Asia/Kolkata"); // IST timezone

                            // Format the IST timestamp according to your desired format
                            invoice.payment_due_date_iso =
                                istMoment.format("DD/MM/yyyy");
                        } else {
                            invoice.payment_due_date_iso = "";
                        }

                        if (typeof invoice.status_reason === "undefined") {
                            invoice.status_reason = "";
                        }
                    });

                    this.collectionSize = this.responseData.invoice.length;
                    this.refreshInvoices();
                    this.loading = false;
                } else {
                    this.loading = false;
                    this.isEmpty = true;
                }
            },
            (error) => {
                if (error.status === 401) {
                    this.sessionExpired = true;
                    this.errorMsg = error.error.msg;
                    this.loading = false;
                }
            }
        );
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");

        this.fetchInvoices();
        this.fetchVendorData();

        if (
            localStorage.getItem("impersonation") === null ||
            localStorage.getItem("impersonation") === ""
        ) {
            this.impersonate = "false";
        } else {
            this.impersonate = localStorage.getItem("impersonation");
        }
    }

    exportToExcel() {
        const date = new Date();

        const fileName =
            (this.displayName = localStorage.getItem("vendorCode")) +
            "_Invoices_Table_" +
            formatDate(date, "dd_MM_yyyy_h_mm_a", this.locale);

        if (this.selectedOption === false) {
            this.tableData = this.invoices;
        } else {
            this.tableData = this.invs;
        }

        const cols = [
            {
                name: "Invoice No",
                colKey: "invoice_number",
            },
            {
                name: "Barcode No",
                colKey: "barcode",
            },
            {
                name: "PO No",
                colKey: "po_number",
            },
            {
                name: "Invoice Amount",
                colKey: "invoice_amount",
            },
            {
                name: "Currency",
                colKey: "po_currency",
            },
            {
                name: "Current Status",
                colKey: "status",
            },
            {
                name: "Payment Due Date",
                colKey: "payment_due_date",
            },
        ];

        this.exportService.exportToExcel(this.tableData, cols, fileName);
    }

    accountLogout() {
        const userData = {
            session: { sessionId: localStorage.getItem("userSession") },
        };
        this.authService.logOut(userData).subscribe(
            (res) => {
                const responseData: any = res;
                if (responseData.status === "ok") {
                    localStorage.clear();
                    this.router.navigateByUrl("/");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    refreshInvoices() {
        let sortedInvoices = this.invoices.sort((a, b) =>
            a.creation_date_sys > b.creation_date_sys ? 1 : -1
        );

        sortedInvoices.forEach((e) => {
            if (
                this.checkObjectKeyExist(e, "rejections", "rej1") === undefined
            ) {
                Object.assign(e, { rejection1: false });
            } else {
                Object.assign(e, { rejection1: true });
            }

            if (
                this.checkObjectKeyExist(e, "rejections", "rej2") === undefined
            ) {
                Object.assign(e, { rejection2: false });
            } else {
                Object.assign(e, { rejection2: true });
            }

            if (this.checkObjectKeyExist(e, "gst_reconciled") === undefined) {
                Object.assign(e, { gst_exist: false });
            } else {
                Object.assign(e, { gst_exist: true });
            }
        });

        this.invs = sortedInvoices
            .map((po, i) => ({ id: i + 1, ...po }))
            .slice(
                (this.page - 1) * this.pageSize,
                (this.page - 1) * this.pageSize + this.pageSize
            );
    }

    orderBy(prop: string) {
        return this.invs.sort((a, b) =>
            a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1
        );
    }

    onFilter(option: any) {
        this.filterBy = option.target.value;
        this.selectedOption = true;
    }

    onSearch(event: KeyboardEvent) {
        this.searchTerm = (event.target as HTMLInputElement).value;

        if (this.searchTerm !== "") {
            if (this.filterBy === "invoice_number") {
                this.invs = this.invoices.filter((data) =>
                    data.invoice_number
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else if (this.filterBy === "po_number") {
                this.invs = this.invoices.filter((data) =>
                    data.po_number
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else if (this.filterBy === "barcode") {
                this.invs = this.invoices.filter((data) =>
                    data.barcode
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            } else if (this.filterBy === "status") {
                this.invs = this.invoices.filter((data) =>
                    data.status
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
                );
            }
        } else {
            this.invs = this.invoices;
        }
    }

    generalSearch(event: KeyboardEvent) {
        this.searchTerm = (event.target as HTMLInputElement).value;

        if (this.searchTerm !== "") {
            this.invs = this.invoices.filter(
                (data) =>
                    data.invoice_number
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.po_number
                        .toString()
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.barcode
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase()) ||
                    data.status
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase())
            );
        } else {
            this.invs = this.invoices;
        }
    }

    checkObjectKeyExist(obj, ...args) {
        return args.reduce((obj, level) => obj && obj[level], obj);
    }
}
